"use strict";
exports.__esModule = true;
exports.toTile = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var TILE_FORMAT_PRISMIC_TO_LGLP = {
    Carré: types_1.TileFormat.square,
    Rectangle: types_1.TileFormat.rectangle
};
var TILE_TYPE_PRISMIC_TO_LGLP = {
    Popin: types_1.TileType.popin,
    Image: types_1.TileType.image,
    Gif: types_1.TileType.gif,
    Sondage: types_1.TileType.survey
};
var SURVEY_TILE_CTA_PRISMIC_TO_GLP = {
    'Icône retourner': types_1.TileSurveyCTA.swap
};
var toTile = function (data, logger) {
    var prismicTile = utils_1.unprefix('tile', data);
    if (prismicTile) {
        return utils_1.compact({
            format: logger.required(logger.toConstValue(prismicTile.format, TILE_FORMAT_PRISMIC_TO_LGLP)),
            type: logger.required(logger.toConstValue(prismicTile.type_content, TILE_TYPE_PRISMIC_TO_LGLP)),
            survey_cta: logger.toConstValue(prismicTile.survey_cta, SURVEY_TILE_CTA_PRISMIC_TO_GLP),
            link: fields_1.toLink(prismicTile.link, logger),
            square_image: logger.required(fields_1.toImage(prismicTile.square_image, logger)),
            rectangle_image: logger.required(fields_1.toImage(prismicTile.rectangle_image, logger))
        });
    }
};
exports.toTile = toTile;
//# sourceMappingURL=tile.js.map